import { QueryOptions, useAppApi, useApiQuery, ImagesApi, useMyProfile, useUpdateQuery } from 'api'
import { PurchasedProduct } from 'api/domain/images'
import { cacheKeys } from 'api/cacheKeys'

export function useImageDetail(id: string, options?: QueryOptions<PurchasedProduct>) {
  const myProfile = useMyProfile()
  const imagesApi = useAppApi(ImagesApi)
  const method = myProfile.data ? 'getPrivateImageById' : 'getImageById'

  const updateDetailImage = useUpdateQuery(cacheKeys.imageDetail(id, !!myProfile.data))

  const query = useApiQuery<PurchasedProduct>(
    cacheKeys.imageDetail(id, !!myProfile.data),
    () => imagesApi[method](id),
    {
      refetchOnMount: true,
      ...options,
    },
  )

  return { updateDetailImage, ...query }
}
